import React from "react";
import { Container, Header } from "./Styled";
import { Button } from "antd";
import { useSelector, useDispatch } from 'react-redux'
import {RootState} from '../../../../model/rootReducer/'
import { Intent } from "../../../../model/intent/types";
import Item from "./Item/Item"
import MenuList, { Item as MenuItem } from "../../../system/menuList";
import { buildBot } from "../../../../business/actions/botActions";

type IntentListProps = {
  onSelect: (intent?: Intent | null) => void
  selectedIntentId: string | undefined | null;
};

const IntentList: React.FunctionComponent<IntentListProps> = props => {
  const intents = useSelector((state: RootState) => state.intent.intents)
  const dispatch = useDispatch();

  const renderHeader = () =>  {
    return <Header><Button onClick={() => props.onSelect(undefined)}>+</Button><Button onClick={() => dispatch(buildBot())}>Build All</Button></Header>
  }

  return (
    <Container>
      <MenuList
        header={renderHeader()}
        onSelect={props.onSelect}
        dataSource={intents}
        renderItem={(item: Intent) => (
          <MenuItem isSelected={item.id === props.selectedIntentId} onSelect={() => props.onSelect(item)}> 
            <Item title={item.title}  sentenceCount={item.expressions.length}/>
          </MenuItem> 
        )}
      />
    </Container>
  );
};

export default IntentList;
